import store_laboratoire from '@/store/mods/analyses/laboratoire'
import { MOTIFS_REJET, CONTENANTS_DEFAUT, contenant_par_defaut, libelle_contenant, libelle_type_echantillon, imprimer_etiquettes } from '@/utils/etiquettes-echantillons'

// LAB-003 : enregistrement d'un échantillon reçu de l'extérieur (structure ou prescripteur externe).
const message = (error, fallback) => error && error.response && error.response.data && typeof error.response.data.message === 'string' ? error.response.data.message : fallback

function formulaire_vide() {
    return {
        nom_patient: '', sexe: '', telephone: '', prescripteur_nom: '', structure: '', reference_externe: '',
        renseignement_clinique: '', preleve_at: '', decision: 'accepte', motif: '', commentaire: '', est_urgent: false
    }
}

export default {
    name: 'echantillon-externe',
    components: {},
    props: {
        toggler: Number
    },
    data() {
        return {
            modal: false,
            is_saving: false,
            catalogue_loading: false,
            erreur: '',
            resultat: null,
            recherche: '',
            analyses_selectionnees: [],
            tubes: [],
            sequence_tubes: 0,
            motifs: MOTIFS_REJET,
            contenants: CONTENANTS_DEFAUT,
            form: formulaire_vide()
        }
    },

    watch: {
        toggler() {
            this.ouvrir()
        },

        analyses_selectionnees() {
            this.synchroniser_tubes()
        }
    },

    computed: {
        categories() {
            const categories = (this.$store && this.$store.getters) ? this.$store.getters['categoriesAnalyses'] : []
            return Array.isArray(categories) ? categories : []
        },

        analyses_plates() {
            const liste = []
            this.categories.forEach((categorie) => {
                const analyses = Array.isArray(categorie.analyses) ? categorie.analyses : []
                analyses.forEach((analyse) => {
                    liste.push({ id: analyse.id, nom: analyse.nom, prix: analyse.prix, type_echantillon: analyse.type_echantillon ? analyse.type_echantillon : null, contenant_code: analyse.contenant_code ? analyse.contenant_code : null, categorie: categorie.nom })
                })
            })
            return liste
        },

        analyses_filtrees() {
            const recherche = this.recherche.trim().toLowerCase()
            if (!recherche) return this.analyses_plates
            return this.analyses_plates.filter(analyse => (String(analyse.nom) + ' ' + String(analyse.categorie)).toLowerCase().indexOf(recherche) !== -1)
        },

        analyses_choisies() {
            return this.analyses_plates.filter(analyse => this.analyses_selectionnees.indexOf(analyse.id) !== -1)
        },

        motif_obligatoire() {
            return this.form.decision === 'accepte_avec_reserve'
        }
    },

    mounted() {

    },

    methods: {
        ouvrir() {
            this.form = formulaire_vide()
            this.analyses_selectionnees = []
            this.tubes = []
            this.recherche = ''
            this.resultat = null
            this.erreur = ''
            this.modal = true
            this.charger_catalogue()
            this.charger_referentiel()
        },

        // LAB-002-B : contenants et motifs du référentiel de la Clinique (repli local sinon)
        charger_referentiel() {
            return store_laboratoire.getReferentiel().then((response) => {
                if (response && response.success && response.data) {
                    if (Array.isArray(response.data.contenants) && response.data.contenants.length) this.contenants = response.data.contenants
                    if (response.data.motifs_rejet) {
                        const motifs = []
                        Object.keys(response.data.motifs_rejet).forEach((id) => { motifs.push({ id: id, libelle: response.data.motifs_rejet[id] }) })
                        if (motifs.length) this.motifs = motifs
                    }
                }
            }).catch(() => {
                this.contenants = CONTENANTS_DEFAUT
            })
        },

        libelle_contenant(code) { return libelle_contenant(code, this.contenants) },
        libelle_option(contenant) {
            return contenant.libelle + (contenant.type_echantillon ? ' — ' + libelle_type_echantillon(contenant.type_echantillon) : '')
        },
        // Analyses proposables dans la carte : celles qui ne sont pas déjà affectées à un autre contenant
        analyses_disponibles(index) {
            const ailleurs = []
            this.tubes.forEach((tube, position) => { if (position !== index) tube.analyse_ids.forEach(id => ailleurs.push(id)) })
            return this.analyses_choisies.filter(analyse => ailleurs.indexOf(analyse.id) === -1)
        },
        analyses_restantes() {
            const affectees = []
            this.tubes.forEach(tube => tube.analyse_ids.forEach(id => affectees.push(id)))
            return this.analyses_choisies.filter(analyse => affectees.indexOf(analyse.id) === -1)
        },
        tout_affecte(index) {
            const disponibles = this.analyses_disponibles(index)
            return disponibles.length > 0 && disponibles.every(analyse => this.tubes[index].analyse_ids.indexOf(analyse.id) !== -1)
        },
        basculer_tout(index) {
            this.tubes[index].analyse_ids = this.tout_affecte(index) ? [] : this.analyses_disponibles(index).map(analyse => analyse.id)
            this.suggerer_contenant(this.tubes[index])
        },
        // Le type d'échantillon découle du contenant, sinon des analyses cochées
        type_du_tube(tube) {
            const contenant = this.contenants.filter(item => item.code === tube.contenant_code)[0]
            if (contenant && contenant.type_echantillon) return contenant.type_echantillon
            const analyse = this.analyses_choisies.filter(item => tube.analyse_ids.indexOf(item.id) !== -1 && item.type_echantillon)[0]
            return analyse ? analyse.type_echantillon : 'autre'
        },
        analyse_dans_tube(tube, analyse_id) { return tube.analyse_ids.indexOf(analyse_id) !== -1 },
        basculer_analyse_tube(tube, analyse_id) {
            if (this.analyse_dans_tube(tube, analyse_id)) {
                tube.analyse_ids = tube.analyse_ids.filter(id => id !== analyse_id)
            } else {
                tube.analyse_ids = tube.analyse_ids.concat([analyse_id])
                this.suggerer_contenant(tube)
            }
        },
        // Tant qu'aucun contenant n'est choisi, la première analyse cochée propose son contenant par défaut du catalogue (modifiable)
        suggerer_contenant(tube) {
            if (tube.contenant_code) return
            const analyse = this.analyses_choisies.filter(item => tube.analyse_ids.indexOf(item.id) !== -1)[0]
            if (!analyse) return
            tube.contenant_code = contenant_par_defaut(analyse.type_echantillon ? analyse.type_echantillon : 'autre', this.contenants, analyse.contenant_code)
        },

        charger_catalogue() {
            if (!this.$store || typeof this.$store.dispatch !== 'function') return Promise.resolve()
            this.catalogue_loading = true
            return this.$store.dispatch('getCategoriesAnalyses').then(() => {
                this.catalogue_loading = false
            }).catch(() => {
                this.catalogue_loading = false
                this.erreur = 'Le catalogue des analyses est indisponible.'
            })
        },

        est_choisie(id) {
            return this.analyses_selectionnees.indexOf(id) !== -1
        },

        basculer_analyse(id) {
            if (this.est_choisie(id)) {
                this.analyses_selectionnees = this.analyses_selectionnees.filter(item => item !== id)
            } else {
                this.analyses_selectionnees = this.analyses_selectionnees.concat([id])
            }
            this.synchroniser_tubes()   // immédiat (le watcher rejoue sans effet)
        },

        // LAB-002-E : rien n'est coché par défaut. Les analyses choisies au catalogue restent à affecter dans des cartes
        // « Contenant » ; une carte vidée par un décochage disparaît, une carte ajoutée encore vide est conservée.
        synchroniser_tubes() {
            const conserves = this.tubes.filter((tube) => {
                const avant = tube.analyse_ids.length
                tube.analyse_ids = tube.analyse_ids.filter(id => this.analyses_selectionnees.indexOf(id) !== -1)
                return avant === 0 || tube.analyse_ids.length > 0
            })
            if (!this.analyses_selectionnees.length) { this.tubes = []; return }
            if (!conserves.length) conserves.push(this.nouveau_tube())
            this.tubes = conserves
        },

        nouveau_tube() {
            return { key: ++this.sequence_tubes, contenant_code: '', nombre: 1, analyse_ids: [] }
        },

        ajouter_tube() {
            if (this.tubes.length && !this.analyses_restantes().length) return
            this.tubes.push(this.nouveau_tube())
        },

        retirer_tube(index) {
            this.tubes.splice(index, 1)
        },

        analyses_du_tube(tube) {
            return this.analyses_choisies.filter(analyse => tube.analyse_ids.indexOf(analyse.id) !== -1).map(analyse => analyse.nom)
        },

        valider() {
            if (!this.form.nom_patient.trim()) return 'Indiquez le nom du patient.'
            if (!this.form.prescripteur_nom.trim()) return 'Indiquez le prescripteur ou la structure d\'origine.'
            if (!this.analyses_selectionnees.length) return 'Choisissez au moins une analyse.'
            for (let index = 0; index < this.tubes.length; index++) {
                const nombre = Number(this.tubes[index].nombre)
                if (!this.tubes[index].contenant_code) return 'Choisissez un contenant pour le contenant ' + (index + 1) + '.'
                if (!this.tubes[index].analyse_ids.length) return 'Cochez au moins une analyse pour le contenant ' + (index + 1) + ', ou retirez-le.'
                if (!Number.isInteger(nombre) || nombre < 1 || nombre > 10) return 'Le nombre de tubes identiques doit être entre 1 et 10.'
            }
            const sans_contenant = this.analyses_choisies.filter(analyse => !this.tubes.some(tube => tube.analyse_ids.indexOf(analyse.id) !== -1))
            if (sans_contenant.length) return 'Chaque analyse doit être affectée à un contenant : ' + sans_contenant.map(analyse => analyse.nom).join(', ') + '.'
            if (this.motif_obligatoire && !this.form.motif) return 'Indiquez le motif de la réserve.'
            return ''
        },

        preleve_at_serveur() {
            const valeur = String(this.form.preleve_at || '').trim()
            if (!valeur) return null
            const normalisee = valeur.replace('T', ' ')
            return /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(normalisee) ? normalisee.substr(0, 16) : null
        },

        payload() {
            const texte = valeur => (valeur && String(valeur).trim()) ? String(valeur).trim() : null
            return {
                patient: { nom_patient: this.form.nom_patient.trim(), sexe: this.form.sexe ? this.form.sexe : null, telephone: texte(this.form.telephone) },
                prescripteur: { nom: this.form.prescripteur_nom.trim(), structure: texte(this.form.structure) },
                reference_externe: texte(this.form.reference_externe),
                renseignement_clinique: texte(this.form.renseignement_clinique),
                analyses: this.analyses_selectionnees.slice(),
                echantillons: this.tubes.map(tube => ({ type_echantillon: this.type_du_tube(tube), contenant_code: tube.contenant_code, nombre: Number(tube.nombre) || 1, analyse_ids: tube.analyse_ids.slice() })),
                preleve_at: this.preleve_at_serveur(),
                decision: this.form.decision,
                motif_rejet: this.motif_obligatoire ? this.form.motif : null,
                commentaire: texte(this.form.commentaire),
                est_urgent: this.form.est_urgent ? true : false
            }
        },

        enregistrer() {
            if (this.is_saving) return Promise.resolve()
            const erreur = this.valider()
            if (erreur) {
                this.erreur = erreur
                return Promise.resolve()
            }
            this.is_saving = true
            this.erreur = ''
            return store_laboratoire.enregistrerExterne(this.payload()).then((response) => {
                if (!response || response.success !== true) throw new Error('Enregistrement refusé')
                this.resultat = { reference: response.reference, patient: response.patient, echantillons: Array.isArray(response.echantillons) ? response.echantillons : [] }
                this.is_saving = false
                this.$emit('emitExterneEnregistre', this.resultat)
            }).catch((error) => {
                this.is_saving = false
                this.erreur = message(error, 'L\'échantillon externe n\'a pas été enregistré.')
            })
        },

        imprimer() {
            if (!this.resultat) return
            imprimer_etiquettes({ patient: this.resultat.patient, reference: this.resultat.reference }, this.resultat.echantillons)
        },

        fermer() {
            this.modal = false
        },

        libelle_type(type) {
            return libelle_type_echantillon(type)
        }
    }
}
